import { render, staticRenderFns } from "./Givs.vue?vue&type=template&id=2f540b6b&"
import script from "./Givs.vue?vue&type=script&lang=js&"
export * from "./Givs.vue?vue&type=script&lang=js&"
import style0 from "./Givs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports